export const NATIONALITIES = [
	{ en: 'Algerian', ar: 'جزائري' },
	{ en: 'Bahraini', ar: 'بحريني' },
	{ en: 'Comorian', ar: 'قمري' },
	{ en: 'Djiboutian', ar: 'جيبوتي' },
	{ en: 'Egyptian', ar: 'مصري' },
	{ en: 'Iraqi', ar: 'عراقي' },
	{ en: 'Jordanian', ar: 'أردني' },
	{ en: 'Kuwaiti', ar: 'كويتي' },
	{ en: 'Lebanese', ar: 'لبناني' },
	{ en: 'Libyan', ar: 'ليبي' },
	{ en: 'Mauritanian', ar: 'موريتاني' },
	{ en: 'Moroccan', ar: 'مغربي' },
	{ en: 'Omani', ar: 'عُماني' },
	{ en: 'Palestinian', ar: 'فلسطيني' },
	{ en: 'Qatari', ar: 'قطري' },
	{ en: 'Saudi / Saudi Arabian', ar: 'سعودي' },
	{ en: 'Somali', ar: 'صومالي' },
	{ en: 'Sudanese', ar: 'سوداني' },
	{ en: 'Syrian', ar: 'سوري' },
	{ en: 'Tunisian', ar: 'تونسي' },
	{ en: 'Emirati', ar: 'إماراتي' },
	{ en: 'Yemeni', ar: 'يمني' },
];
